module.exports = __webpack_public_path__ + "media/images/flags/aw-b3753c38cad90dd24c37f6e98f81ecd1.svg";